// src/components/ArticleCard.tsx
import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn'; // 引入中文包
import { Link } from 'react-router-dom';
dayjs.extend(relativeTime);
dayjs.locale('zh-cn'); // 设置为中文

interface ArticleCardProps {
    id: number;
    title: string;
    author: string;
    date: string;
    summary: string;
    coverImage?: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ id, title, author, date, summary, coverImage }) => {
    // 格式化为"5月12日"
    const formattedDate = dayjs(date).format('M月D日');
    // 随机生成点赞和评论数（实际项目应由后端返回）
    const likeCount = Math.floor(20 + Math.random() * 80);
    const commentCount = Math.floor(5 + Math.random() * 30);

    return (
        <div className="card">
            <div className="card-meta" style={{ marginBottom: 10 }}>
                作者：{author}
            </div>
            <Link to={`/article/${id}`} className="card-link-area" style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="card-content-wrapper">
                    {/* 左侧文章信息 */}
                    <div className="card-info">
                        <h2 className="card-title" style={{ marginBottom: 12 }}>{title}</h2>
                        <div className="card-text">{summary}</div>
                        <div className="card-meta-bar">
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
                                    <defs>
                                        <linearGradient id="clock-gradient" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="0%" stopColor="#FFD700" />
                                            <stop offset="100%" stopColor="#FFA500" />
                                        </linearGradient>
                                    </defs>
                                    <circle cx="8" cy="8" r="7" fill="url(#clock-gradient)" stroke="#FFA500" strokeWidth="1" />
                                    <rect x="7.5" y="4" width="1" height="5" rx="0.5" fill="#fff" />
                                    <rect x="7.5" y="8" width="4" height="1" rx="0.5" fill="#fff" />
                                </svg>
                                {formattedDate}
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
                                    <defs>
                                        <linearGradient id="like-gradient" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0%" stopColor="#ff7e5f" />
                                            <stop offset="100%" stopColor="#feb47b" />
                                        </linearGradient>
                                    </defs>
                                    <path d="M8 14s-5-3.33-5-7.5A3.5 3.5 0 0 1 8 3a3.5 3.5 0 0 1 5 3.5C13 10.67 8 14 8 14z" fill="url(#like-gradient)" stroke="#ff7e5f" strokeWidth="1" />
                                </svg>
                                {likeCount}
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <svg width="16" height="16" viewBox="0 0 16 16" style={{ marginRight: 4 }}>
                                    <defs>
                                        <linearGradient id="comment-gradient" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0%" stopColor="#43cea2" />
                                            <stop offset="100%" stopColor="#185a9d" />
                                        </linearGradient>
                                    </defs>
                                    <path d="M2 2h12v9H5.414L2 14V2z" fill="url(#comment-gradient)" stroke="#185a9d" strokeWidth="1" />
                                </svg>
                                {commentCount}
                            </span>
                        </div>
                    </div>
                    {/* 右侧封面图片 */}
                    {coverImage && (
                        <div className="card-cover">
                            <img src={coverImage} alt={title} />
                        </div>
                    )}
                </div>
            </Link>
        </div>
    );
};

export default ArticleCard;